import moment from 'moment-jalaali'
import { emptySelectedUserByAdminAction } from '../service/actions/accessActions'
import { resetUserPackagesAction } from '../service/actions/packageAction'
import { resetProps } from '../service/actions/profileActions'
import * as Yup from 'yup'


const fileFormatDataBinary = {
  doc: 'data:application/msword;base64,',
  dot: 'data:application/msword;base64,',
  docx: 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,',
  dotx: 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.template;base64,',
  docm: 'data:application/vnd.ms-word.document.macroEnabled.12;base64,',
  dotm: 'data:application/vnd.ms-word.template.macroEnabled.12;base64,',
  xls: 'data:application/vnd.ms-excel;base64,',
  xlt: 'data:application/vnd.ms-excel;base64,',
  xla: 'data:application/vnd.ms-excel;base64,',
  xlsx: 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,',
  xltx: 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.template;base64,',
  xlsm: 'data:application/vnd.ms-excel.sheet.macroEnabled.12;base64,',
  xltm: 'data:application/vnd.ms-excel.template.macroEnabled.12;base64,',
  xlam: 'data:application/vnd.ms-excel.addin.macroEnabled.12;base64,',
  xlsb: 'data:application/vnd.ms-excel.sheet.binary.macroEnabled.12;base64,',
  rar: 'data:application/vnd.rar;base64,',
  svg: 'data:image/svg+xml;base64,',
  pdf: 'data:application/pdf;base64,',
  png: 'data:image/png;base64,',
  mp3: 'data:audio/mpeg;base64,',
  gif: 'data:image/gif;base64,',
  ico: 'data:image/vnd.microsoft.icon;base64,',
  jpeg: 'data:image/jpeg;base64,',
  jpg: 'data:image/jpeg;base64,',
  json: 'data:application/json;base64,',
  csv: 'data:text/csv;base64,',
  avi: 'data:	video/x-msvideo;base64,',
  tif: 'data:image/tiff;base64,',
  tiff: 'data:image/tiff;base64,',
  txt: 'data:text/plain;base64,',
  wav: 'data:audio/wav;base64,',
  zip: 'data:application/zip;base64,',
  ppt: 'data:application/vnd.ms-powerpoint;base64,',
}
export const validURL = (str) => {
  var pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$',
    'i',
  ) // fragment locator
  return !!pattern.test(str)
}

export const makeid = (length) => {
  var result = ''
  var characters = '0123456789'
  var charactersLength = characters.length
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export const isValidURL = (string) => {
  var res = string.match(
    /(http(s):\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
  )
  return res !== null
}

export const isValidHttpUrl = (string) => {


  const hasProtocol = /(?<=^|\s)(\w*-?\w+\.[a-z]{2,}\S*)/.test(string);
  const hasWWWW = /(?:^|\s)(www\.[\w-]+\.[a-z]{2,}\S*)/i.test(string);

  if (!hasProtocol) {
    return false;
  }
  if (hasWWWW) {
    return false
  }
  return true;

}

export const enToPersianChar = (str) => {
  var pn = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
  var en = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']

  var temp = str + ''
  for (var i = 0; i < 10; i++) {
    var regex_en = new RegExp(en[i], 'g')
    temp = temp.replace(regex_en, pn[i])
  }
  return temp
}

export const toEnglishNumber = (num) => {
  if (num) {
    let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g]
    num = num.toString()
    for (var i = 0; i < 10; i++) {
      num = num.replace(persianNumbers[i], i)
    }
    return num
  } else {
    return num
  }
}

export const checkForNumericEnFaString = (str) => {
  if (str !== undefined) {
    var res = ''
    res = str.toString().match(/[0-9]/i)
    res = res + str.toString().match(/[۰-۹]/i)
    return res
  } else {
    return null
  }
}

export const checkForNumericFaString = (str) => {
  if (str !== undefined) {
    var res = ''
    res = res + str.toString().match(/[۰-۹]/i)
    return res
  } else {
    return null
  }
}

export const createNowPaymentURL = ({
  invoiceId,
  orderId,
  paymentAmount,
  customerEmail,
  customerName,
  paymentCurrency,
}) => {
  var data = `{"ipnURL":"https:\/\/client.mhaghshenas.ir\/modules\/gateways\/callback\/nowpayments.php","successURL":"https:\/\/dev.siponline.ir\/#\/payBack\/${invoiceId}","cancelURL":"https:\/\/dev.siponline.ir\/#\/payBack\/${invoiceId}","dataSource":"whmcs","paymentCurrency":"${paymentCurrency}","apiKey":"R52F9Q1-39B4RPS-H103Y4H-X24WGW4","customerName":"${customerName}","customerEmail":"${customerEmail}","paymentAmount":"${paymentAmount}","orderID":"${orderId}"}`
  return `https://nowpayments.io/payment?data=${encodeURIComponent(data)}`
}

export const CommaSeparator = (num) => {
  return num?.toLocaleString();
}

export const output = ([gDate, iDay, iMonth, iYear, tD, gStart, gEnd]) => {
  // console.log(`
  // Gregorian Date              : ${gDate}
  // Persian Day                 : ${iDay}
  // Persian Month               : ${iMonth}
  // Persian Year                : ${iYear}
  // Total Days in Persian Month : ${tD}
  // Persian Month Starts on     : ${gStart}
  // Persian Month Ends on       : ${gEnd}
  // `
  // );
}

export const ticketAttachmentFormat = () => {
  return {
    // "audio/mpeg": true,
    // "audio/mp3": true,
    'image/jpeg': true,
    'image/jpg': true,
    'image/png': true,
    'image/gif': true,

    'application/pdf': true,
    // "application/x-zip-compressed": true,
    // "video/mp4": true,
    // "text/plain": true,

    // "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true
  }
}

export const fileToBase64 = async (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result.split(',')[1])
    reader.onerror = reject
  })

export const getPersianMonthName = (monthNum) => {
  const months = {
    1: 'فروردین',
    2: 'اردیبهشت',
    3: 'خرداد',
    4: 'تیر',
    5: 'مرداد',
    6: 'شهریور',
    7: 'مهر',
    8: 'آبان',
    9: 'آذر',
    10: 'دی',
    11: 'بهمن',
    12: 'اسفند',
  }
  return months[monthNum + 1]
}

export const publicWHMCSUrlPice = (parameters) => {
  let url =
    '1url1/includes/api.php?endpoint=1url1/includes/api.php&identifier=1identifier1&secret=1secret1&accesskey=1accesskey1&responsetype=json&'
  Object.keys(parameters).map((item) => {
    url += `&${item}=${parameters[item]}`
  })
  // return endpoint + encodeURIComponent(url);
  return url
}

export const createFileToDownload = (fileDetail) => {
  const element = document.createElement('a')
  const fileFormat = fileDetail.filename.split('.')[fileDetail.filename.split('.').length - 1]
  if (fileFormatDataBinary[fileFormat]) {
    element.setAttribute('href', fileFormatDataBinary[fileFormat] + fileDetail?.data)
    element.setAttribute('download', fileDetail.filename)
    element.style.display = 'none'
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
    return true
  } else {
    return false
  }
}

export const protocolRemoval = (link) => {
  if (link.indexOf("http://") > -1) {
    return link.split('http://')[1]
  }

  if (link.indexOf('https://') > -1) {
    return link.split('https://')[1]
  }
  return link
}

export const changeLanguage = (i18n, direction) => {
  if (direction === 'rtl') {
    i18n.changeLanguage('en')
  } else {
    i18n.changeLanguage('fa')
  }
  window.location.reload();

}
export const phoneNumberFormat = (number) => {
  if (number) {
    if (number.length === 3) return number

    if (number[0] === '0' || number[0] === '۰') number = '+۹۸' + number.substring(1)

    if (number.substring(0, 4) === '+989' || number.substring(0, 4) === '+۹۸۹')
      return '۰' + number.substring(3, 6) + ' ' + number.substring(6, 9) + ' ' + number.substring(9)
    else
      return '۰' + number.substring(3, 5) + ' ' + number.substring(5, 9) + ' ' + number.substring(9)
  }

};

export const isValidEmailStrictly = (email) => {
  if (!email.trim())
    return false;
  var persianOrASCII = /[آ-ی]/;

  if (email.trim().match(persianOrASCII)) {
    return false;
  }

  if (email.includes('/')) {
    return false;
  }

  ///[. - _]
  if (/^[._-]/.test(email) || /[._-]$/.test(email)) {
    return false
  }

  /// two points
  if (/\.\./.test(email)) {
    return false
  }

  var mainDomainStartIndex = email.trim().lastIndexOf('.');

  if (mainDomainStartIndex === -1)
    return false;

  var mainDomain = email.trim().slice((email.trim().length - mainDomainStartIndex - 1) * -1).toLowerCase();
  var validMainDomains = ['com', 'org', 'info', 'ir', 'net', 'cm', 'biz', 'ru', 'ac', 'co', 'de', 'in', 'ml', 'om', 'us', 'uk', 'tv', 'pro', 'edu', 'ca', 'io'];

  if (validMainDomains.every(function (value) { return value !== mainDomain })) {
    return false;
  }
  if (email.trim().split('@').length > 2) {
    return false;
  }

  return true;
}



export const durationTextHandling = (lng, duration, item) => {
  if (lng === 'fa') {
    if (duration === 'Month') {
      return 'ماهانه'
    }
    if (duration === 'Year') {
      return 'سالانه'
    }
    if (item) {
      return item.packageNameFa === "بسته‌ی رایگان" ? "" : duration

    } else {
      return duration

    }
  }

  if (lng === 'en') {
    if (duration === 'Month') {
      return 'Monthly'
    }
    if (duration === 'Year') {
      return 'Yearly'
    }
    if (item) {
      return item.packageNameEn === "Free Package" ? "" : duration

    } else {
      return duration

    }

  }
}

export const setLoginLocalStorageProps = (loginResponse) => {
  return new Promise((resolve) => {
    localStorage.setItem('accessToken', loginResponse.token)
    localStorage.setItem('refreshToken', loginResponse.refreshToken)
    localStorage.setItem('userMenu', loginResponse.jsonMenu)

    const state = {
      email: loginResponse.email,
      userId: loginResponse.userId,
      ipAnalysis: loginResponse.ipAnalysis,
      tenants: loginResponse.tenants,
    }

    localStorage.setItem('sipOnlineUser', JSON.stringify(state))
    checkLocalStorageAndProceed("sipOnlineUser", () => {
      resolve(state);

    })
  });
};

export const setLoginLocalStorageFromLoginAsProps = (loginResponse, token) => {
  return new Promise((resolve) => {
    localStorage.setItem('accessToken', token)
    localStorage.setItem('refreshToken', '')
    localStorage.setItem('userMenu', loginResponse.menuJson)

    let tenants = JSON.parse(loginResponse?.tenants);

    const state = {
      email: loginResponse.email,
      userId: loginResponse.name,
      ipAnalysis: false,
      tenants: tenants,
    }

    localStorage.setItem('sipOnlineUser', JSON.stringify(state))
    checkLocalStorageAndProceed("sipOnlineUser", () => {
      resolve(state);

    })
  });
};

export const customTrim = (email) => {
  if (email) {
    return email.replace(/\s+/g, '')
  }
  return ''
}

export const miladyToPersianDate = (dateStr, format, exportFormat) => {
  const momentDate = moment(dateStr, format).local('fa').format(exportFormat)
  return momentDate
}

export const registerWizardStorageHandling = (step, stepName, stepModel) => {
  let registerWizardStorage = localStorage.getItem('registerWizardStorage')
  if (!registerWizardStorage) {
    registerWizardStorage = { passedStep: [] }
  } else {
    registerWizardStorage = JSON.parse(registerWizardStorage)
  }

  registerWizardStorage.passedStep.push(step)
  registerWizardStorage[stepName] = stepModel

  localStorage.setItem('registerWizardStorage', JSON.stringify({ ...registerWizardStorage }))
  localStorage.setItem("payRef", "wizard")

}

export const registerWizardStepValidating = (step) => {
  let registerWizardStorage = localStorage.getItem('registerWizardStorage')
  registerWizardStorage = JSON.parse(registerWizardStorage)
  return {
    registerWizardStorage,
    idValid: !registerWizardStorage || registerWizardStorage.passedStep.indexOf(step) === -1,
  }
}

export const resetWizardStorage = () => {
  localStorage.removeItem('registerWizardStorage')
}

export const cleanStorage = (dispatch) => {

  return new Promise((resolve) => {
    dispatch(emptySelectedUserByAdminAction())
    localStorage.removeItem("sipOnlineUser")
    localStorage.removeItem("accessToken")
    localStorage.removeItem("refreshToken")
    localStorage.removeItem("multiTenants")
    localStorage.removeItem("selectedUser")
    localStorage.removeItem("token")
    localStorage.removeItem("profile")
    localStorage.removeItem("userMenu")
    localStorage.removeItem("tab")


    dispatch(resetUserPackagesAction())
    dispatch(resetProps())
    clearLocalStorageAndProceed("accessToken", () => {
      resolve()

    })
  })

}

export const getPackageTypeFeatureBaseCount = ({ _package, type }) => {
  const feature = _package?.packageType?.features?.find((i) => i.title.indexOf(type) > -1)
  if (feature) {
    return feature.baseCount
  }
  return 0;
}

export const numberDisplayHandler = (number, lngSelected) => {
  if (number) {
    if (lngSelected && lngSelected?.language === 'fa') {
      return enToPersianChar(number)
    }
    return number;
  }
  return ""
}

export const clearLocalStorageAndProceed = (item, callback) => {
  // localStorage.clear();

  if (!localStorage.getItem(item)) {
    callback();
  } else {
    clearLocalStorageAndProceed(item, callback)
    console.error('Failed to clear localStorage.');
  }
}

export const checkLocalStorageAndProceed = (item, callback) => {


  if (localStorage.getItem(item)) {
    callback();
  } else {
    checkLocalStorageAndProceed(item, callback)
    console.error('Failed to get localStorage.');
  }
}
export const isValidEmailOfUser = (t) => {

  return Yup.string()
    .matches(
      /^(?![._+-])[a-zA-Z0-9]+(?:[._+-][a-zA-Z0-9]+)*(?<![._+-])@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      t('NOT_CORRECT_EMAIL').toString(),
    ).required(t('RQUIRE_EMAIL').toString())

};

export const phoneNumberValidation = (phone) => {
  if (!phone) {
    return false
  }
  if (!/^(?:(\u0660\u0669[\u0660-\u0669][\u0660-\u0669]{8})|(\u06F0\u06F9[\u06F0-\u06F9][\u06F0-\u06F9]{8})|(09[0-9][0-9]{8}))$/.test(phone)) {
    return false

  }
  return true
}

export const cleanStorageLimited = (dispatch) => {

  return new Promise((resolve) => {
    dispatch(emptySelectedUserByAdminAction())
    localStorage.removeItem("sipOnlineUser")
    localStorage.removeItem("token")
    localStorage.removeItem("profile")
    localStorage.removeItem("userMenu")
    localStorage.removeItem("accessToken")
    localStorage.removeItem("refreshToken")

    dispatch(resetUserPackagesAction())
    dispatch(resetProps())
    clearLocalStorageAndProceed("userMenu", () => {
      resolve()

    })
  })

}

export const detectionPrivateRoute = () => {
  const freeRoutes = [
    "/dashboard/",
    "/settings/",
    "/profile",
    "/deactivateUsr",
    "/userTransactions",
    "/mypackage",
    "/domain",
    "/teamMembers",
    "/callReport",
    "/chat",
    "/profileTenant/",
    "/addTenantMember",
    "/payBack/",
    "/support",
    "/invoice",
    "/domainDisplaySettings/",
    "/domainNonWorkingHoursSettings/",
    "/domainLimitationSettings/",
    "/domainBehaviorSettings/",
    "/domainDisplaySettings/",
    "/domainSurvey/",
    "/domainPredefinedResponsesSettings/",
    "/domainResponseDelaySettings/",
    "/domainAutoMessageSettings/",
    "/domainConversationStartSettings/",
    "/domainQueueSettings/",
    "/domainLackOfResponsivenessSettings/",
    "/domainAudioFilesSettings/",
    "/domainWorkingHoursSettings/",
  ]
  if (window.location.pathname === "/" || freeRoutes.some(route => window.location.pathname.indexOf(route) > -1)) {
    window.location.href = "/login"
  }


}

export const shortLinkDetection = () => {
  const freeRoutes = [
    "/dashboard/",
    "/settings/",
    "/profile",
    "/deactivateUsr",
    "/userTransactions",
    "/mypackage",
    "/domain",
    "/teamMembers",
    "/callReport",
    "/chat",
    "/profileTenant/",
    "/addTenantMember",
    "/payBack/",
    "/support",
    "/invoice",
    "/domainDisplaySettings/",
    "/domainNonWorkingHoursSettings/",
    "/domainLimitationSettings/",
    "/domainBehaviorSettings/",
    "/domainDisplaySettings/",
    "/domainSurvey/",
    "/domainPredefinedResponsesSettings/",
    "/domainResponseDelaySettings/",
    "/domainAutoMessageSettings/",
    "/domainConversationStartSettings/",
    "/domainQueueSettings/",
    "/domainLackOfResponsivenessSettings/",
    "/domainAudioFilesSettings/",
    "/domainWorkingHoursSettings/",
    "/tmr/", "/loginInstances", "/signup", "/login", "/pay", "/bankBack", "/packages", "/vcodeLogin", "/getPassword", "/shortLink", "/recoveryPassword", "/ResetPassword"
  ]

  if (window.location.pathname !== "/") {
    if (!freeRoutes.some(route => window.location.pathname.indexOf(route) === -1)) {
      window.location.href = `/shortLink${window.location.pathname}`

    }
  }


}

export const disableInput = (id) => {

  const input = document.getElementById(id)
  if (input) {
    input.disabled = true;
  }
}

export const browswerDetection = (userAgent) => {
  if (/Edg\//.test(userAgent)) return 'Edge';
  if (/OPR\//.test(userAgent)) return 'Opera';
  if (/Chrome\//.test(userAgent)) return 'Chrome';
  if (/Safari\//.test(userAgent)) return 'Safari';
  if (/Firefox\//.test(userAgent)) return 'Firefox';
  return 'Unknown';
}

export const getpersianDataTime = (isoDate) => {
  const jDate = moment(isoDate).format('jYYYY/jMM/jDD HH:mm');
  return jDate;
}

export const enWeekdays = { 0: 'Saturday', 1: 'Monday', 2: 'Tuesday', 3: 'Wednesday', 4: 'Thursday', 5: 'Friday', 6: 'Sunday' }
export const faWeekdays = { 0: 'شنبه', 1: 'یکشنبه', 2: 'دوشنبه', 3: 'سه‌شنبه', 4: 'چهارشنبه', 5: 'پنجشنبه', 6: 'جمعه' }

